//	Ref: https://github.com/Phrogz/context-blender
//	Note: lifted the 'normal' and added blendif with configurable rgb

//	Creates a blendable image in a canvas context
const blendOnto = (srcContext, destContext, blendMode, blendOptions, offsetOptions) => {
	const defaultOffsets = { destX: 0, destY: 0, sourceX: 0, sourceY: 0, width: 'auto', height: 'auto' }
	const defaultBlendOptions = { r: 248, b: 248, g: 248 }
	const offsets = Object.assign({}, defaultOffsets, offsetOptions)
	const options = Object.assign({}, defaultBlendOptions, blendOptions)
	if (offsets.width === 'auto') {
		offsets.width = srcContext.canvas.width
	}
	if (offsets.height === 'auto') {
		offsets.height = srcContext.canvas.height
	}

	offsets.width = Math.min(offsets.width, srcContext.canvas.width - offsets.sourceX, destContext.canvas.width - offsets.destX)
	offsets.height = Math.min(offsets.height, srcContext.canvas.height - offsets.sourceY, destContext.canvas.height - offsets.destY)

	const srcD = srcContext.getImageData(offsets.sourceX, offsets.sourceY, offsets.width, offsets.height)
	const dstD = destContext.getImageData(offsets.destX, offsets.destY, offsets.width, offsets.height)
	const src = srcD.data
	const dst = dstD.data
	let sA
	let dA
	const len = dst.length
	let sRA
	let sGA
	let sBA
	let dRA
	let dGA
	let dBA
	let dA2
	let r1
	let g1
	let b1
	let r2
	let g2
	let b2
	let demultiply

	for (let px = 0; px < len; px += 4) {
		sA = src[px + 3] / 255
		dA = dst[px + 3] / 255
		dA2 = (sA + dA - sA * dA)
		dst[px + 3] = dA2 * 255

		r1 = dst[px]
		g1 = dst[px + 1]
		b1 = dst[px + 2]
		r2 = src[px]
		g2 = src[px + 1]
		b2 = src[px + 2]

		sRA = r2 / 255 * sA
		dRA = r1 / 255 * dA
		sGA = g2 / 255 * sA
		dGA = g1 / 255 * dA
		sBA = b2 / 255 * sA
		dBA = b1 / 255 * dA

		demultiply = 255 / dA2

		const f1 = dA * sA
		const f2 = dA - f1
		const f3 = sA - f1

		// eslint-disable-next-line default-case
		switch (blendMode) {
		case 'normal':
		case 'src-over':
			dst[px] = (sRA + dRA - dRA * sA) * demultiply
			dst[px + 1] = (sGA + dGA - dGA * sA) * demultiply
			dst[px + 2] = (sBA + dBA - dBA * sA) * demultiply
			break

			//	The "blend if gray", but with configurable rgb.
		case 'blendif':
			// eslint-disable-next-line no-case-declarations
			const shouldBlend = r2 > options.r && g2 > options.g && b2 > options.b
			if (shouldBlend) {
				dst[px] = 0
				dst[px + 1] = 0
				dst[px + 2] = 0
				dst[px + 3] = 0
			} else {
				dst[px] = f1 * r2 + f2 * r1 + f3 * r2
				dst[px + 1] = f1 * g2 + f2 * g1 + f3 * g2
				dst[px + 2] = f1 * b2 + f2 * b1 + f3 * b2
			}
			break
		}
	}
	destContext.putImageData(dstD, offsets.destX, offsets.destY)
}

export default blendOnto



// WEBPACK FOOTER //
// ./src/utilities/Flatlay/blendOnto.js